export default "/_next/static/src/lib/assets/rive/bc6316470886daa61e9b02f3b41289db.riv";